import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DividerModule } from './../../common/divider/divider.module';
import { GroupModule } from './../../common/group/group.module';
import { DialogFooterComponent } from './dialog-footer.component';

@NgModule({
  declarations: [DialogFooterComponent],
  exports: [DialogFooterComponent],
  imports: [GroupModule, CommonModule, DividerModule],
})
export class DialogFooterModule {}
export { DialogFooterComponent } from './dialog-footer.component';
